import { render, staticRenderFns } from "./MainSettingsType.vue?vue&type=template&id=3249135e&scoped=true"
import script from "./MainSettingsType.vue?vue&type=script&lang=js"
export * from "./MainSettingsType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3249135e",
  null
  
)

export default component.exports